export default {
  en: {
    'APPLY_FILTERS': 'Apply Updated Filters',
    'EDIT_FILTERS': 'Edit filters',
    'CLEAR_FILTERS': 'Clear filters'
  }
};